<template lang="pug">
  ModalBase(ref="modalBase" size="medium")
    template(slot="header") 注文者先情報
    template(slot="body")
      FormItem 
        template(slot="title")
          FormLabel(type="required") 氏名
        template(slot="input")
          FormTextfield(v-model="form.contactName" placeholder="氏名を入力してください"
            :error="'contactName' in $_validationErrorMessage"
            :errorMessage="$_validationErrorMessage.contactName")
      FormItem
        template(slot="title")
          FormLabel シメイ(カナ)
        template(slot="input")
          FormTextfield(v-model="form.contactNameKana" placeholder="シメイ(カナ)を入力してください"
            :error="'contactNameKana' in $_validationErrorMessage"
            :errorMessage="$_validationErrorMessage.contactNameKana")
      FormItem
        template(slot="title")
          FormLabel(type="required") 電話番号
        template(slot="input")
          FormTextfield(v-model="form.contactTel" placeholder="電話番号を入力してください"
            :error="'contactTel' in $_validationErrorMessage"
            :errorMessage="$_validationErrorMessage.contactTel")
      FormItem
        template(slot="title")
          FormLabel(type="required") 郵便番号
        template(slot="input")
          FormTextfield(v-model="form.contactZipCode" placeholder="郵便番号を入力してください"
            :error="'contactZipCode' in $_validationErrorMessage"
            :errorMessage="$_validationErrorMessage.contactZipCode")
      FormItem
        template(slot="title")
          FormLabel(type="required") 都道府県
        template(slot="input")
          FormTextfield(v-model="form.contactPrefecture" placeholder="都道府県を入力してください"
            :error="'contactPrefecture' in $_validationErrorMessage"
            :errorMessage="$_validationErrorMessage.contactPrefecture")
      FormItem
        template(slot="title")
          FormLabel(type="required") 市区町村
        template(slot="input")
          FormTextfield(v-model="form.contactCity" placeholder="市区町村を入力してください"
            :error="'contactCity' in $_validationErrorMessage"
            :errorMessage="$_validationErrorMessage.contactCity")
      FormItem
        template(slot="title")
          FormLabel(type="required") 地区番地
        template(slot="input")
          FormTextfield(v-model="form.contactAddress1" placeholder="地区番地を入力してください"
            :error="'contactAddress1' in $_validationErrorMessage"
            :errorMessage="$_validationErrorMessage.contactAddress1")
      FormItem
        template(slot="title")
          FormLabel() ビル建物名
        template(slot="input")
          FormTextfield(v-model="form.contactAddress2" placeholder="ビル建物名を入力してください"
            :error="'contactAddress2' in $_validationErrorMessage"
            :errorMessage="$_validationErrorMessage.contactAddress2")
    template(slot="footer")
      ButtonBase(@click="close()" variant="normal" size="inline") キャンセル
      ButtonBase(@click="updateSubscriptionOrder()" variant="primary") 更新
</template>

<script>
  import GlobalMixin from '../../../mixin/GlobalMixin'
  import ModalBase from '../modal/ModalBase'
  import ButtonBase from '../button/ButtonBase'
  import FormItem from '../form/FormItem'
  import FormLabel from '../form/FormLabel'
  import FormTextarea from '../form/FormTextarea'
  import FormPulldown from '../../form/FormPulldown.vue'
  import {
    GetSubscriptionOrderSelectOptions,
  } from "../../../graphqls/SubscriptionOrderSummaries";
  import {UpdateSubscriptionOrder} from "../../../graphqls/SubscriptionOrder";
  import FormTextfield from "../form/FormTextfield.vue";
  import FormMessage from "../../form/FormMessage.vue";

  export default {
    name: 'ModalSubscriptionContact',
    mixins: [GlobalMixin],
    components: {
      FormMessage,
      FormTextfield,
      ModalBase,
      ButtonBase,
      FormItem,
      FormLabel,
      FormTextarea,
      FormPulldown,
    },
    data() {
      return {
        form: {
          id: '',
          contactName: "",
          contactNameKana: "",
          contactTel: "",
          contactZipCode: "",
          contactPrefecture: "",
          contactCity: "",
          contactAddress1: "",
          contactAddress2: "",
        },
        selectOptions: {
          subscriptionOrderIntervalOptions: [],
          orderDeliveryTimeOptions: [],
        }
      }
    },
    props: {
      subscriptionOrder: {
        type: Object,
        default () {
          return {
            id: null,
            contactName: "",
            contactNameKana: "",
            contactTel: "",
            contactZipCode: "",
            contactPrefecture: "",
            contactCity: "",
            contactAddress1: "",
            contactAddress2: "",
          }
        }
      },
    },
    watch: {
      subscriptionOrder(newVal) {
        for (let key in this.form) {
          this.form[key] = newVal[key] || "";
        }
      }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
      async getSelectOption() {
        this.loadingStart();
        const { data } = await this.$apollo
            .query({
              query: GetSubscriptionOrderSelectOptions,
              client: 'apiClient'
            })
            .catch(error => {
              this.loadingStop()
              return;
            });
        this.selectOptions = data.selectOptions
        this.loadingStop();
      },
      open() {
        this.$refs.modalBase.open()
        this.$emit('open')
      },
      close() {
        this.$refs.modalBase.close()
        this.$emit('close')
      },
      async updateSubscriptionOrder() {
        this.loadingStart();
        console.log('{ ...this.form }', { ...this.form })
        const { data } = await this.$apollo
            .mutate({
              mutation: UpdateSubscriptionOrder,
              // Parameters
              variables: {
                input: { ...this.form }
              },
              client: 'apiClient'
            })
            .catch(error => {
              console.log(error.message)
            });
        const errors = data.updateSubscriptionOrder.errors
        if (!errors) {
          this.close()
          this.$emit('update', data.updateSubscriptionOrder)
        } else {
          console.log(errors)
          this.$_parseError(errors)
        }
        this.loadingStop();
      },

    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../assets/stylesheets/v1/styles";

  .modal-base {
    .body {
      section {
        .heading {
          font-family: $font-family-sans;
          font-weight: $font-weight-bold;
          font-style: $font-style-not-italic;
          @include font-size(sm);
          line-height: $line-height-snug;
          color: $black-400;
          @include margin-bottom(md);
        }

        .info {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;

          > .quantity {
            @include margin-right(sm);
          }
          > .price {
            font-weight: 700;
          }
          > .unit {
            @include font-size(xxs)
          }
        }
      }
    }
  }
</style>
